import { Form, InputNumber, Modal, Select, Switch } from '@maxtropy/components';
import { Space, Spin } from 'antd';
import {
  apiV2AreaGetAllMediumValveDetailPost,
  apiV2AreaUpsertAutoControlPost,
} from '@maxtropy/device-customer-apis-v2';
import { ValveDevice } from '../types';
import { InfoCircleOutlined } from '@ant-design/icons/lib/icons';
import { useRequest } from 'ahooks';

interface AutoControlConfigModalProps {
  visible: boolean;
  device?: ValveDevice;
  areaId?: number;
  mediumId?: number;
  onCancel: () => void;
  onOk: () => void;
}

const AutoControlConfigModal: React.FC<AutoControlConfigModalProps> = ({
  visible,
  device,
  areaId,
  mediumId,
  onCancel,
  onOk,
}) => {
  const [form] = Form.useForm();
  const autoControlEnabled = Form.useWatch('autoControlEnabled', form);

  const { loading } = useRequest(
    () => apiV2AreaGetAllMediumValveDetailPost({ id: areaId, mediumId, deviceId: device!.deviceId }),
    {
      onSuccess: data => {
        form.setFieldsValue({
          ...data.valveAutoControlDetail,
          autoCloseTime: data.valveAutoControlDetail?.autoCloseTime ?? 0,
          autoOpenTime: data.valveAutoControlDetail?.autoOpenTime ?? 0,
          autoOpenType: (data.valveAutoControlDetail as any)?.autoOpenType ?? 0,
          autoCloseType: (data.valveAutoControlDetail as any)?.autoCloseType ?? 1,
        });
      },
      ready: visible && !!device?.deviceId,
      refreshDeps: [visible, device?.deviceId, mediumId, areaId],
    }
  );

  const handleOk = () => {
    form.validateFields().then(values => {
      apiV2AreaUpsertAutoControlPost({
        id: areaId,
        mediumId,
        deviceId: device!.deviceId,
        deviceName: device!.deviceName,
        ...values,
      }).then(() => {
        onOk();
      });
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={`自动控制配置-${device?.deviceName}`}
      open={visible}
      size="large"
      onCancel={handleCancel}
      onOk={handleOk}
      maskClosable={false}
      contentClassName="modal-form-content"
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="horizontal"
          initialValues={{
            autoControlEnabled: false,
            autoOpenTime: 0,
            autoCloseTime: 0,
            autoOpenType: 0,
            autoCloseType: 1,
          }}
        >
          <Form.Item name="autoControlEnabled" label="自动控制" valuePropName="checked">
            <Switch checkedChildren="开" unCheckedChildren="关" />
          </Form.Item>
          {autoControlEnabled && (
            <>
              <Form.Item label="自动开启">
                <Space style={{ color: 'var(--mx-text-secondary-color)' }} size={8}>
                  <Form.Item name="autoOpenType" noStyle>
                    <Select style={{ width: 70 }}>
                      <Select.Option value={0}>前置</Select.Option>
                      <Select.Option value={1}>后置</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item name="autoOpenTime" noStyle>
                    <InputNumber placeholder="请输入" min={0} addonAfter="s" />
                  </Form.Item>
                  自动开启控制
                </Space>
              </Form.Item>
              <Form.Item label="自动关闭">
                <Space style={{ color: 'var(--mx-text-secondary-color)' }} size={8}>
                  <Form.Item name="autoCloseType" noStyle>
                    <Select style={{ width: 70 }}>
                      <Select.Option value={0}>前置</Select.Option>
                      <Select.Option value={1}>后置</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item name="autoCloseTime" noStyle>
                    <InputNumber placeholder="请输入" min={0} addonAfter="s" />
                  </Form.Item>
                  自动关闭控制
                </Space>
              </Form.Item>
              <Space style={{ color: 'var(--mx-text-secondary-color)' }} size={4}>
                <InfoCircleOutlined style={{ color: 'var(--warning-color)' }} />
                设置值为0时，则在计划开始/结束时间点立即执行；前置代表提前开启/提前关闭；后置代表延时开启/延时关闭；
              </Space>
            </>
          )}
        </Form>
      </Spin>
    </Modal>
  );
};

export default AutoControlConfigModal;
